import { authenticatedApi } from '../../../shared/api/apiClientUtils';

export interface CompanyDetailsResponse {
  isConfigured: boolean;
  companyName: string;
  companyNumber: string | null;
  addressLine1: string;
  addressLine2: string | null;
  city: string;
  county: string | null;
  postcode: string;
  country: string | null;
  companyEmail: string;
  companyPhone: string;
}

export interface UpsertCompanyDetailsRequest {
  companyName: string;
  companyNumber: string | null;
  addressLine1: string;
  addressLine2: string | null;
  city: string;
  county: string | null;
  postcode: string;
  country: string | null;
  companyEmail: string;
  companyPhone: string;
}

export async function getCompanyDetails(): Promise<CompanyDetailsResponse> {
  const { data } = await authenticatedApi.get<CompanyDetailsResponse>(
    '/api/v1/organisations/company-details'
  );
  return data;
}

export async function upsertCompanyDetails(
  request: UpsertCompanyDetailsRequest
): Promise<CompanyDetailsResponse> {
  const { data } = await authenticatedApi.put<CompanyDetailsResponse>(
    '/api/v1/organisations/company-details',
    request
  );
  return data;
}
